import React from 'react';
import ShopIcon from './../../../assets/images/ShopIcon.png'
import { Link, useNavigate } from 'react-router-dom';
import $ from "jquery";
import logo from "./../../../assets/images/logo1.png";
import { useState } from 'react';
import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import FooterContact from '../FooterContact';


var CryptoJS = require("crypto-js");

const CheckEmail = () => {
    let navigate = useNavigate();
    const [email, setEmail] = useState('');

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [apiData, setApiData] = useState([]);

    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }


    async function fetchData() {

        const requestParam = {
            email_address: email,
        };

        let token = CryptoJS.AES.encrypt(JSON.stringify(requestParam), process.env.REACT_APP_SECURITY_SALT).toString()

        await fetch(process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_API_PREFIX + "panel/company-registration-request/checkEmail", {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),

            body: JSON.stringify({ ...requestParam, token: token })

        }).then(res => res.json()).then(
            (result) => {
                setIsLoaded(true);
                setApiData(result);
                return navigate("/company-registration-step-one?name="+(result['data']?.name?.toString() ?? "")+"&email="+(result['data']?.email_address?.toString() ?? "")+"&mobile="+(result['data']?.mobile_number?.toString() ?? ""));
            },
            (error) => {
                setIsLoaded(true);
                setError(error);
                toast.error(error?.messages?.toString() ?? "A problem occur.");

                $("#submit_btn").attr("disabled", false);
                $("#submit_btn").html("Next");
                $('#submit_btn').css({ opacity: '1' });
            }
        )
    }


    useEffect(() => {
        window.history.replaceState({}, "");

        if (isLoaded === true) {
            if (error) {
                console.log(error.messages.toString());
                return;
            }

            let response = JSON.stringify(apiData);
            response = JSON.parse(response);

            if (response["code"] === 200) {
                // return navigate("/company-registration-step-one?name="+response['data']?.name);
            }

            $('#submit_btn').css({ opacity: '1' });
            $("#submit_btn").attr("disabled", false);
            $("#submit_btn").html("Next");

            toast.error(response["messages"].toString());
        }

    }, [apiData]);


    const handleSubmit = event => {
        event.preventDefault();

        setError(null);
        if (!isValidEmail(email)) {
            toast.error('Email is invalid');
            return;
        }


        $("#submit_btn").attr("disabled", true);
        $("#submit_btn").html("Loading...");
        $('#submit_btn').css({ opacity: '0.6' });


        fetchData();
    }

    const handleChange = (event) => {
        setEmail(event.target.value);
    }



    useEffect(() => {
        $('.btn').css({ opacity: '0.6' });
        $('.btn').attr("disabled", true);

        if (isValidEmail(email)) {
            $('.btn').css({ opacity: '1' });
            $('.btn').attr("disabled", false);
        }

    }, [email]);



    return (
        <section className="h-screen bg-white font-murecho">
            <ToastContainer />
            <div className="h-full justify-center">
                {/* <!-- Left column container with background--> */}


                <div className='flex justify-center'>
                    <img src={logo} alt="" className='absolute top-12' />
                </div>


                <div
                    className="g-6 flex h-full flex-wrap items-center justify-center lg:justify-center">
                    <div
                        className="shrink-1 mb-12 grow-0 basis-auto md:mb-0 ">
                        <img
                            src={ShopIcon}
                            className="hidden mb-10 lg:block"
                            alt="ShareTrip Partner Portal" />
                    </div>

                    {/* <!-- Right column container --> */}
                    <div className="mb-12 md:mb-0 md:w-8/12 lg:w-5/12 xl:w-5/12">

                        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
                            <div className="w-full bg-[#1882FF] rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0">
                                <div className="p-6 sm:p-10">

                                    <p className='text-white text-xl'>Welcome to</p>

                                    <p className="text-xl mb-5 font-semibold leading-8 text-white md:text-[28px] dark:text-white">
                                        ShareTrip Partner Portal
                                    </p>


                                    <span id="thank_you_div" className='hidden'>
                                        <div className='text-white text-sm mb-1 ml-1'>
                                            <p className='font-semibold'>Please check your email. </p>
                                            <div className='mt-1 mb-4'>A registration link has been send to your given email address and will be valid in next 24 hours.</div>
                                        </div>

                                        <Link to={"/"} className="block btn w-full mt-8 mb-3 text-white bg-[#003897] hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg px-6 py-3 text-center opacity-100">Back to login</Link>
                                    </span>


                                    <span id="registration_div">
                                        <form onSubmit={handleSubmit} method="POST">


                                            <p className='text-white font-medium text-sm mb-1 ml-1'>Enter your email address *</p>
                                            <div className='mb-6'>
                                                <input type="email" name="email" value={email} onChange={handleChange} autoComplete='off' id="email" className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="E-mail Address" required="" />
                                            </div>


                                            <button id="submit_btn" disabled={true} className="btn w-full mb-3 text-white bg-[#003897] hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg px-6 py-3 text-center opacity-60 disabled:cursor-not-allowed">Next</button>
                                            <p className='text-white text-sm text-right mr-1'>&larr;&nbsp;<Link to="/" className="text-sm font-medium text-white text-right ml-1">Back to Login</Link></p>
                                        </form>
                                    </span>

                                </div>
                            </div>
                            
                            <FooterContact />
                        </div>


                    </div>
                </div>
            </div>
        </section>
    );
};

export default CheckEmail;